<template>
  <div class="signup-events" v-if="visibleModal">
    <div class="signup-events__overlay">
      <div class="signup-events__content">
        <div class="signup-events__top">
          <p class="signup-events__title">Регистрация на мероприятие</p>
          <button @click="closeModal" class="signup-events__close">
            <i>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L13 13M1 13L13 1" stroke="#333333" stroke-width="1.5" />
              </svg>
            </i>
          </button>
        </div>
        <form class="signup-events__form" @submit.prevent="handleSubmit">
          <div class="signup-events__form-inner">
            <p class="signup-events__form-title">{{ event.title }}</p>
            <p class="signup-events__form-text">
              <b>{{ formatDate(event.startTime) }}</b> {{ formatTime(event.startTime) }} -
              <b v-if="getDayDifference(event.startTime, event.finishTime)">
                {{ formatDate(event.finishTime) }}
              </b>
              {{ formatTime(event.finishTime) }}
            </p>
            <p class="signup-events__form-subtitle">Количество мест: {{ count }}</p>
            <div class="signup-events__form-input-group">
              <div class="signup-events__form-input-pair">
                <div :class="['signup-events__form-input-wrap', nameClass]">
                  <input v-model="form.name" type="text" class="signup-events__form-input" placeholder="Введите Имя*"
                    @blur="validateField('name')" />
                  <p v-if="errors.name">Имя не введено</p>
                </div>
                <div :class="['signup-events__form-input-wrap', surnameClass]">
                  <input v-model="form.surname" type="text" class="signup-events__form-input"
                    placeholder="Введите Фамилию*" @blur="validateField('surname')" />
                  <p v-if="errors.surname">Фамилия не введена</p>
                </div>
              </div>
              <div class="signup-events__form-input-pair">
                <div :class="['signup-events__form-input-wrap', emailClass]">
                  <input v-model="form.email" type="text" class="signup-events__form-input" placeholder="E-mail*"
                    @blur="validateField('email')" />
                  <p v-if="errors.email">E-mail не введен</p>
                </div>
                <div :class="['signup-events__form-input-wrap', phoneClass]">
                  <input v-model="form.phone" type="text" class="signup-events__form-input"
                    :placeholder="requiredPhone ? 'Телефон*' : 'Телефон (опционально)'" @blur="validatePhoneField"
                    @input="formatPhone" />
                  <p v-if="errors.phone">{{ errors.phone }}</p>
                </div>
              </div>
            </div>
          </div>
          <p class="signup-events__form-condition">
            Нажимая кнопку, я соглашаюсь с
            <a target="_blank" :href="agreementLink">Условиями оказания услуг МойДвиж</a>
          </p>
          <button class="signup-events__form-btn" :disabled="loading">Зарегистрироваться</button>
        </form>
      </div>
    </div>
  </div>
  <Thank v-if="showThank" :eventTitle="event.title" @close="handleThankClose" />
  <Error v-if="showError" :errorText="errorText" @close="handleErrorClose" />
</template>

<script>
import axios from 'axios';
import Thank from "./Thank.vue";
import Error from "./Error.vue";
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';

export default {
  name: 'SignUpEvent',
  components: { Thank, Error },
  props: {
    event: Object,
    count: Number,
    requiredPhone: Boolean,
  },
  emits: ['close', 'refresh'],
  data() {
    return {
      visibleModal: true,
      form: {
        name: "",
        surname: "",
        email: "",
        phone: "",
      },
      errors: {
        name: false,
        surname: false,
        email: false,
        phone: false,
      },
      loading: false,
      showSignUpEvent: true,
      showThank: false,
      showError: false,
      agreementLink: null,
      errorText: 'Извините, регистрация не удалась по техническим причинам. Попробуйте ещё раз.',
    };
  },
  computed: {
    nameClass() {
      return this.errors.name ? "error" : this.form.name ? "success" : "";
    },
    surnameClass() {
      return this.errors.surname ? "error" : this.form.surname ? "success" : "";
    },
    emailClass() {
      return this.errors.email ? "error" : this.form.email ? "success" : "";
    },
    phoneClass() {
      return this.errors.phone ? "error" : this.form.phone ? "success" : "";
    },
  },
  methods: {
    formatDate(date) {
      const options = { day: 'numeric', month: 'long' };
      return new Date(date).toLocaleDateString('ru-RU', options);
    },
    formatTime(date) {
      const options = { hour: '2-digit', minute: '2-digit' };

      // Создаем объект Date из переданной строки
      const time = new Date(date);

      // Получаем смещение текущего часового пояса (в часах)
      const userTimezoneOffset = time.getTimezoneOffset() / 60;

      // Корректируем время, прибавляя смещение
      time.setHours(time.getHours() - userTimezoneOffset);

      // Применяем форматирование времени
      return time.toLocaleTimeString('ru-RU', options);
    },
    getDayDifference(startTime, finishTime) {
      const startDate = new Date(startTime);
      const finishDate = new Date(finishTime);
      const dayDiff = Math.floor((finishDate - startDate) / (1000 * 60 * 60 * 24));
      return dayDiff > 0 ? `+${dayDiff}` : '';
    },
    closeModal(success) {
      if (success){
        this.$emit('close', true);
      } else {
        this.$emit('close', false);        
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.closeModal();
      }
    },

    validateField(field) {
      if (field === "name") {
        this.errors.name = !this.form.name.trim();
      } else if (field === "surname") {
        this.errors.surname = !this.form.surname.trim();
      } else if (field === "email") {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.errors.email = !emailPattern.test(this.form.email.trim());
      }
    },
    formatPhone(event) {
      const input = event.target.value.replace(/\D/g, ''); // Убираем все нецифровые символы
      let formatted = '+7';
      if (input.length > 1) formatted += ` (${input.slice(1, 4)}`;
      if (input.length >= 5) formatted += `) ${input.slice(4, 7)}`;
      if (input.length >= 8) formatted += ` ${input.slice(7, 9)}`;
      if (input.length >= 10) formatted += ` ${input.slice(9, 11)}`;
      this.form.phone = formatted;
    },
    validatePhoneField() {
      if (this.requiredPhone) {
        const phoneRegex = /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;
        if (!phoneRegex.test(this.form.phone)) {
          this.errors.phone = 'Неверный формат номера телефона';
        } else {
          this.errors.phone = null;
        }
      } else {
        this.errors.phone = null; // Поле не обязательно, поэтому ошибки нет
      }
    },
    async handleSubmit() {
      this.validateField("name");
      this.validateField("surname");
      this.validateField("email");
      if (this.requiredPhone) {
        this.validateField("phone");
      }

      if (this.errors.name || this.errors.surname || this.errors.email || (this.requiredPhone && this.errors.phone)) {
        return;
      }

      this.loading = true;

      try {
        await axios.post("/api/pis/v1/for_account/reserv", {
          eventId: this.event.id,
          reservCount: this.count || 1,
          name: this.form.name,
          surname: this.form.surname,
          email: this.form.email,
          phone: this.form.phone || null,
        });

        this.showThank = true;
        this.visibleModal = false;
        this.$emit('refresh');
      } catch (error) {
        if (error.response.status == 400) {
          this.errorText = error.response.data.message;
        }
        this.showError = true;
        this.visibleModal = false;
      } finally {
        this.loading = false;
      }
    },
    handleThankClose() {
      this.showThank = false;
      this.closeModal(true);
    },
    handleErrorClose() {
      this.showError = false;
      this.closeModal(false);
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);

    fetch('/config.json')
      .then(response => response.json())
      .then(config => {
        this.agreementLink = config.agreement;
      })
      .catch(error => {
        console.error('Ошибка загрузки конфигурации:', error);
      });
  },
};
</script>
